import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { EmailValidator } from 'src/app/template/customValidators/emailValidator';

export var GipRequestDnloadForm =
  new FormGroup({
    G3E_ID: new FormControl(),
    G3E_FID: new FormControl('', Validators.maxLength(10)),
    PERSON_ID: new FormControl(),
    CONTRACT_ID: new FormControl(),
    C_PERSON_ID: new FormControl('', Validators.maxLength(201)),
    DELIVERY_STATE: new FormControl(),
    C_DELIVERY_STATE: new FormControl('', Validators.maxLength(100)),
    REQUEST_STATE: new FormControl(),
    C_REQUEST_STATE: new FormControl('', Validators.maxLength(100)),
    ACTIVITY_TYPE: new FormControl(),
    C_ACTIVITY_TYPE: new FormControl('', Validators.maxLength(100)),
    REASON_TYPE: new FormControl(),
    C_REASON_TYPE: new FormControl('', Validators.maxLength(100)),
    BEGIN_ACTIVITY_DT: new FormControl(),
    END_ACTIVITY_DT: new FormControl(),
    REQUEST_DT: new FormControl(),
    EXPIRATION_DT: new FormControl(),
    RESPONSIBLE_PERSON: new FormControl('', Validators.maxLength(100)),
    RESPONSIBLE_PERSON_TEL_NUM: new FormControl('', Validators.maxLength(100)),
    PERSON_EMAIL: new FormControl(EmailValidator),
    LOCATION_DESC: new FormControl('', Validators.maxLength(256)),
    LOCATION: new FormControl('', Validators.maxLength(315)),
    COMPANY: new FormControl('', Validators.maxLength(100)),
    C_REQUESTOR: new FormControl('', Validators.maxLength(201)),
    G3E_ID_FILE: new FormControl(),
    G3E_ID_FILE_MAPSHEET_NUM: new FormControl(),
    G3E_ID_FILE_USERNAME: new FormControl(),
    G3E_ID_FILE_DOWNLOAD_DT: new FormControl(),
    G3E_ID_FILE_DOWNLOADAMIN: new FormControl(),
    G3E_ID_FILE_DOWNLOAD: new FormControl(),
  });

export var GipReqReplotForm =
  new FormGroup({
    G3E_FID: new FormControl('', Validators.maxLength(10)),
    PERSON_ID: new FormControl(),
    CONTRACT_ID: new FormControl(),
    REQUESTOR: new FormControl(),
    ROLE: new FormControl(),
    FULLNAME: new FormControl('', Validators.maxLength(201)),
    PERSON_EMAIL: new FormControl(),
    DELIVERY_STATE: new FormControl(),
    REQUEST_STATE: new FormControl(),
    ACTIVITY_TYPE: new FormControl(),
    REASON_TYPE: new FormControl(),
    SCALE: new FormControl('', Validators.required),
    FORMAT: new FormControl('', Validators.required),
    BEGIN_ACTIVITY_DT: new FormControl(),
    END_ACTIVITY_DT: new FormControl(),
    REQUEST_DT: new FormControl(),
    EXPIRATION_DT: new FormControl(),
    RESPONSIBLE_PERSON: new FormControl('', Validators.maxLength(100)),
    RESPONSIBLE_PERSON_TEL_NUM: new FormControl('', Validators.maxLength(100)),
    LOCATION_DESC: new FormControl('', Validators.maxLength(256)),
    SEARCH_METHOD: new FormControl(),
    ADDRESS_ID: new FormControl(),
    PARCEL_ID: new FormControl(),
    LOCATION: new FormControl('', Validators.maxLength(315)),
    COMPANY: new FormControl('', Validators.maxLength(100)),
  });

export var GipReqStatusForm = new FormGroup({
  G3E_FID: new FormControl('', Validators.maxLength(10)),
  RQTITLE: new FormControl('', Validators.maxLength(100)),
  PERSON_ID: new FormControl(),
  SEARCH_METHOD: new FormControl(),
  FULLNAME: new FormControl('', Validators.maxLength(200)),
  DELIVERY_STATE: new FormControl(),
  REQUEST_STATE: new FormControl(),
  ACTIVITY_TYPE: new FormControl('', Validators.maxLength(100)),
  REASON_TYPE: new FormControl('', Validators.maxLength(100)),
  BEGIN_ACTIVITY_DT: new FormControl(),
  END_ACTIVITY_DT: new FormControl(),
  REQUEST_DT: new FormControl(),
  EXPIRATION_DT: new FormControl(),
  RESPONSIBLE_PERSON: new FormControl('', Validators.maxLength(100)),
  RESPONSIBLE_PERSON_TEL_NUM: new FormControl('', Validators.maxLength(100)),
  LOCATION_DESC: new FormControl('', Validators.maxLength(256)),
  PERSON_EMAIL: new FormControl('', [EmailValidator, Validators.maxLength(250)]),
  LOCATION: new FormControl('', Validators.maxLength(315)),
  REQUESTOR: new FormControl(),
  REQUESTOR_NAME: new FormControl('', Validators.maxLength(200)),
  COMPANY: new FormControl('', Validators.maxLength(250)),
  INTNOTE: new FormControl('', Validators.maxLength(500)),
  VPO_TEXT: new FormControl(),
});

